import { Box, Grid2 } from '@mui/material'
import React from 'react'
import { SearchSection, UseSelectBoxFeild } from '../student/MyCourses'
import CustomDivider from '../../shared/utils/CustomDivider'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import AllCoursesCard from '../../shared/components/student/AllCoursesCard'
import { FilterButton } from '../../shared/utils/IconButton'
import { Constants } from '../../shared/constants'
import { useStudentCourse } from '../../assets/api/UseStudentGetApi'
import { GridChildren } from '../../shared/utils/LingtBlueContainer'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'


const StudentsCourses = () => {
  const { data: studentcourses, isLoading } = useStudentCourse();

  return (
    <Box>
      <SearchSection />
      {/* <CustomDivider orientation='horizontal' />

      <ScrollContainerWithHeader headerText={"Related Courses"}>
        {relatedCourseData.map((item, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 8, md: 6 }} sx={{ flex: '0 0 auto' }}>
            <RelatedClassCard img={item.img} name={item.name} />
          </Grid2>
        ))}
      </ScrollContainerWithHeader> */}
      <CustomDivider orientation='horizontal' />
      <NormalContainerWithHeader>
        <FilterButton src={Constants.customImages.FilterDark} />
        <Grid2 children size={2} >
          <UseSelectBoxFeild label="Batch" />
        </Grid2>
        <Grid2 children size={2} >
          <UseSelectBoxFeild label="Course Category" />
        </Grid2>
        <Grid2 children size={2}>
          <UseSelectBoxFeild label="Course Status" />
        </Grid2>
        <Grid2 container spacing={"20px"}>
          {/* {[...Array(6)].map((_, index) => (
            <Grid2 key={index} item size={{ lg: 6, xs: 12 }}>
              <AllCoursesCard status={"Ongoing"} />
            </Grid2>
          ))} */}


          {!isLoading && (
            (Array.isArray(studentcourses?.data)
              ? studentcourses?.data
              : Object.values(studentcourses?.data || {})
            ).map((item, index) => (
              <GridChildren index={index} key={index}>
                <AllCoursesCard status={"Upcoming"} item={item} />
              </GridChildren>
            ))
          )}
          {
            isLoading && (
              [...Array(2)].map((_, index) => (
                <GridChildren index={index} key={index}>
                  <SkeletonCom />
                </GridChildren>
              ))
            )
          }
        </Grid2>
      </NormalContainerWithHeader>
    </Box>
  )
}

export default StudentsCourses